var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5245 21.1875H17.4936C17.2166 21.1875 16.9758 20.9975 16.9098 20.7285L14.0032 8.82608L11.0944 20.7285C11.0284 20.9975 10.7876 21.1875 10.5106 21.1875H1.47752C1.09395 21.1875 0.806277 20.831 0.889384 20.4552L4.06021 6.0912C4.09644 5.92681 4.20086 5.78376 4.34576 5.7005L13.7006 0.269162C13.8881 0.160279 14.1161 0.160279 14.3036 0.269162L23.6563 5.7005C23.8012 5.7859 23.9056 5.92681 23.9418 6.0912L27.1105 20.4552C27.1936 20.831 26.9081 21.1875 26.5224 21.1875H26.5245Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/tent.428e156251ba148dbd02f983f5d2563a.svg";
export { ForwardRef as ReactComponent };